export function DisplayKv({
  list,
}: {
  list: Array<{ label: string; value: string }>;
}) {
  if (list.length === 0) return <div>-</div>;

  return (
    <div className="grid grid-cols-[min-content_1fr] gap-2 border py-1 px-2 place-items-center rounded-lg w-full">
      {list
        .filter(({ label, value }) => !!label || !!value)
        .map(({ label, value }) => (
          <>
            <span key={label} className="whitespace-nowrap">
              {label}
            </span>
            <span key={value}>{value}</span>
          </>
        ))}
    </div>
  );
}
